import { render } from "./inbc2.vue?vue&type=template&id=283e4690&scoped=true"
import script from "./inbc2.vue?vue&type=script&lang=js"
export * from "./inbc2.vue?vue&type=script&lang=js"

import "./inbc2.vue?vue&type=style&index=0&id=283e4690&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283e4690"]])

export default __exports__